import { render, staticRenderFns } from "./BFileInputWithValidation.vue?vue&type=template&id=b8ca974a"
import script from "./BFileInputWithValidation.vue?vue&type=script&lang=js"
export * from "./BFileInputWithValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports